"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highlighter = void 0;
var Highlighter = /** @class */ (function () {
    function Highlighter() {
    }
    Highlighter.highlight = function (str, value) {
        if (value == null) {
            return {
                score: 0,
                parts: [{ content: str, highlighted: false }]
            };
        }
        var length = value.length;
        var indexes = Highlighter.indexesOf(str, value);
        var parts = [];
        Highlighter.addContent(parts, str.substring(0, indexes[0]), false);
        for (var i = 0; i < indexes.length; i++) {
            var index = indexes[i];
            var match = str.substring(index, index + length);
            var other = str.substring(index + length, indexes[i + 1]);
            Highlighter.addContent(parts, match, true);
            Highlighter.addContent(parts, other, false);
        }
        var score = Highlighter.getScore(str, parts);
        return { score: score, parts: parts };
    };
    Highlighter.indexesOf = function (str, value) {
        var indexes = [];
        for (var i = 0; i < str.length; i++) {
            var possible = str.substr(i, value.length);
            if (Highlighter.matches(possible, value)) {
                indexes.push(i);
            }
        }
        return indexes;
    };
    Highlighter.matches = function (a, b) {
        return a.toLowerCase() === b.toLowerCase();
    };
    Highlighter.addContent = function (parts, content, highlighted) {
        if (content == null || content === '') {
            return;
        }
        parts.push({ content: content, highlighted: highlighted });
    };
    Highlighter.getScore = function (str, parts) {
        // How early in the string is the match found
        var firstMatchScore = 1 - (parts.findIndex(function (p) { return p.highlighted; }) / parts.length);
        // How much of the string has been matched
        var matchedCharCount = 0;
        for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
            var part = parts_1[_i];
            if (part.highlighted) {
                matchedCharCount += part.content.length;
            }
        }
        var matchCompletenessScore = matchedCharCount / str.length;
        return firstMatchScore * matchCompletenessScore;
    };
    return Highlighter;
}());
exports.Highlighter = Highlighter;
//# sourceMappingURL=highlighter.js.map